module.exports = __webpack_public_path__ + "static/media/sd.1f9811bf.svg";